
import DemoComponent from './demoModule/Module';
import ToolbarComponent from './mapmodule/Module';
import SearchComponent from './Search/Module';
import RoutePlanComponent from './RoutePlan/Module';

/**
 * 这里export的key是前端调用中，相对应的组件的moduleName
 */
export default {
    Toolbar: ToolbarComponent,
    // 示例组件
    Demo: DemoComponent,
    Search: SearchComponent,
    RoutePlan: RoutePlanComponent,
};

